import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import approvalReducer from "./features/approval/approval-slice";
import isLoginReducer from "./features/auth/isLogin-slice";
import datePickerFilterReducer from "./features/components/datePickerFilter-slice";
import mealCheckActiveOraReducer from "./features/meal/mealCheckActiveOraSlice";
import mealMonitoringDetailReducer from "./features/meal/mealMonitoringDetailSlice";
import mealMonitoringReducer from "./features/meal/mealMonitoringSlice";
import mealReducer from "./features/meal/mealSlice";
import mealUpdateConfigurationReducer from "./features/meal/mealUpdateConfigurationSlice";
import mtcReducer from "./features/mtc/mtc-slice";
import mtcDailyMonitoringReducer from "./features/mtc/mtcDailyMonitoringSlice";
import notificationReducer from "./features/notifications/notificationSlice";
import presenceReducer from "./features/presence/presence-slice";
import userProfileReducer from "./features/profile/userProfile-slice";
import vhsReducer from "./features/vhs/vhs-slice";

export const store = configureStore({
  reducer: {
    isLoginReducer,
    userProfileReducer,
    presenceReducer,
    approvalReducer,
    vhsReducer,
    mtcReducer,
    datePickerFilterReducer,
    notificationReducer,
    mealReducer,
    mealMonitoringReducer,
    mealUpdateConfigurationReducer,
    mealCheckActiveOraReducer,
    mealMonitoringDetailReducer,
    mtcDailyMonitoringReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useAppDispatch: () => AppDispatch = useDispatch;
